export const getUniqueStringFromArray = strList => {
  const duplicateChecker = {};
  strList.forEach(str => (duplicateChecker[str] = str));
  return Object.keys(duplicateChecker);
};

export const removeLastPeriod = str => {
  if (str.charAt(str.length - 1) === ".") {
    return str.slice(0, -1);
  }
  return str;
};
